import {useEffect, useState} from "react";
import {Link, useHistory, useParams} from "react-router-dom";
import {FormSiteGeneralDetails} from "./addEditSite/formSiteGeneralDetails"
import {FormSiteCodes} from "./addEditSite/formSiteCodes";
import {FormSitePaymentProviders} from "./addEditSite/formSitePaymentProviders";
import {FormSiteSpaces} from "./addEditSite/formSiteSpaces";
import Api from "../api/api";
import StringHelpers from "../../utilities/stringHelpers";

export const AddSite = ({ organisationId, token, users }) => {
    const [canSave, setCanSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const { clientId } = useParams();
    const history = useHistory();

    const [name, setName] = useState("");
    const [siteCode, setSiteCode] = useState("");
    const [regionId, setRegionId] = useState(null)
    const [debtCollectionProviderId, setDebtCollectionProviderId] = useState(null)
    const [parkonomySiteCode, setParkonomySiteCode] = useState("");
    const [parkBunnyLocationId, setParkBunnyLocationId] = useState("");
    const [justParkLocationId, setJustParkLocationId] = useState("");
    const [tap2ParkLocationId, setTap2ParkLocationId] = useState("");
    const [payByPhoneLocationId, setPayByPhoneLocationId] = useState("");
    const [ipsLocationId, setIpsLocationId] = useState("");
    const [conviousLocationId, setConviousLocationId] = useState("");
    const [lookingForCarParkLocationId, setLookingForCarParkLocationId] = useState("");
    const [newParkLocationId, setNewParkLocationId] = useState("");
    const [parksoLocationId, setParksoLocationId] = useState("");
    const [myCarPassLocationId, setMyCarPassLocationId] = useState("");
    const [ringGoZone, setRingGoZone] = useState("");
    const [permitPrefix, setPermitPrefix] = useState("");
    const [iasIpcCode, setIasIpcCode] = useState("");
    const [status, setStatus] = useState(false);
    const [allowCancellationOfBreaches, setAllowCancellationOfBreaches] = useState(false)
    const [maximumCancellationsPerMonth, setMaximumCancellationsPerMonth] = useState("")
    const [enableAutoAssignUser, setEnableAutoAssignUser] = useState(false)
    const [vehicleAnalyticsEnabled, setVehicleAnalyticsEnabled] = useState(false)
    const [preventDuplicateBreaches, setPreventDuplicateBreaches] = useState(false)
    const [autoAssignedUser, setAutoAssignUser] = useState("")
    const [contractExpiry, setContractExpiry] = useState("");
    const [jurisdiction, setJurisdiction] = useState("0")
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [addressLine3, setAddressLine3] = useState("");
    const [postCode, setPostCode] = useState("");
    const [townOrCity, setTownOrCity] = useState("");
    const [iasEnabled, setIasEnabled] = useState(false);
    const [bpaEnabled, setBpaEnabled] = useState(false);
    const [bpaCode, setBpaCode] = useState("");
    const [pofaEnabled, setPofaEnabled] = useState(false);
    const [payAndDisplaySpaces, setPayAndDisplaySpaces] = useState(0);
    const [preAllocatedSpaces, setPreAllocatedSpaces] = useState(0);
    const [disabledSpaces, setDisabledSpaces] = useState(0);
    const [permitSpaces, setPermitSpaces] = useState(0);
    const [otherSpaces, setOtherSpaces] = useState(0);

    const submit = function () {
        if (canSave) {
            Api.addSite(
                (data) => {
                    history.push(`/organisation/${ organisationId }/client/${ clientId }/site/${ data.id }`)
                    setErrorMessage("");
                },
                (error) => setErrorMessage(error.errorMessage),
                name, siteCode, iasIpcCode, status, Number(jurisdiction), addressLine1, addressLine2, addressLine3, postCode, townOrCity, iasEnabled, bpaEnabled, bpaCode, pofaEnabled,
                false, 0, 0, 0, 0, 0,
                 null, null, null,
                0, 0, StringHelpers.isNullOrEmpty(contractExpiry) ? null : contractExpiry,
                payAndDisplaySpaces, preAllocatedSpaces, disabledSpaces, permitSpaces, otherSpaces,
                permitPrefix, parkonomySiteCode, ringGoZone, payByPhoneLocationId, justParkLocationId, tap2ParkLocationId, parkBunnyLocationId, ipsLocationId, conviousLocationId,
                null, null, false,
                null,
                StringHelpers.midnightOffsetToTimeString(60),
                StringHelpers.midnightOffsetToTimeString(300), 0,
                StringHelpers.isNullOrEmpty(maximumCancellationsPerMonth) ? null : Number(maximumCancellationsPerMonth),
                !StringHelpers.isNullOrEmpty(autoAssignedUser) ? autoAssignedUser : null,
                vehicleAnalyticsEnabled, regionId,
                lookingForCarParkLocationId,
                newParkLocationId,
                parksoLocationId,
                0,
                myCarPassLocationId,
                preventDuplicateBreaches,
                !StringHelpers.isNullOrEmpty(debtCollectionProviderId) ? debtCollectionProviderId : null,
                organisationId,
                clientId,
                token
            );
        } else {
            setErrorMessage("There are validation errors.");
        }
    }

    useEffect(() => {
        if (
            StringHelpers.isNullOrEmpty(name)
            || StringHelpers.isNullOrEmpty(siteCode)
            || StringHelpers.isNullOrEmpty(addressLine1)
            || StringHelpers.isNullOrEmpty(townOrCity)
            || StringHelpers.isNullOrEmpty(postCode)
        ) {
            setCanSave(false);
        } else {
            setCanSave(true);
        }
    }, [name, siteCode, addressLine1, townOrCity, postCode]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3 border-top details-container">
                        <div className="card-header border-bottom">
                            <div className="row align-items-center">
                                <h5 className="mb-0 px-3">Create New Site</h5>
                            </div>
                        </div>
                        <div className="card-body bg-light details-container">
                            {
                                !StringHelpers.isNullOrEmpty(errorMessage) &&
                                <div className="row">
                                    <div className="offset-md-3 col-md-6">
                                        <p className="error-message">
                                            {errorMessage}
                                        </p>
                                    </div>
                                </div>
                            }
                            <FormSiteGeneralDetails name={name} setName={setName} siteCode={siteCode}
                                                    setSiteCode={setSiteCode} permitPrefix={permitPrefix}
                                                    setPermitPrefix={setPermitPrefix} contractExpiry={contractExpiry}
                                                    setContractExpiry={setContractExpiry} status={status}
                                                    setStatus={setStatus}
                                                    allowCancellationOfBreaches={allowCancellationOfBreaches}
                                                    setAllowCancellationOfBreaches={setAllowCancellationOfBreaches}
                                                    maximumCancellationsPerMonth={maximumCancellationsPerMonth}
                                                    setMaximumCancellationsPerMonth={setMaximumCancellationsPerMonth}
                                                    enableAutoAssignUser={enableAutoAssignUser}
                                                    setEnableAutoAssignUser={setEnableAutoAssignUser}
                                                    autoAssignedUser={autoAssignedUser}
                                                    setAutoAssignUser={setAutoAssignUser} jurisdiction={jurisdiction} setJurisdiction={setJurisdiction} addressLine1={addressLine1}
                                                    setAddressLine1={setAddressLine1} addressLine2={addressLine2}
                                                    setAddressLine2={setAddressLine2} addressLine3={addressLine3}
                                                    setAddressLine3={setAddressLine3} townOrCity={townOrCity}
                                                    setTownOrCity={setTownOrCity} postCode={postCode}
                                                    setPostCode={setPostCode} isNew users={users}
                                                    vehicleAnalyticsEnabled={vehicleAnalyticsEnabled}
                                                    setVehicleAnalyticsEnabled={setVehicleAnalyticsEnabled}
                                                    preventDuplicateBreaches={preventDuplicateBreaches}
                                                    setPreventDuplicateBreaches={setPreventDuplicateBreaches}
                                                    organisationId={organisationId} regionId={regionId}
                                                    setRegionId={setRegionId} debtCollectionProviderId={debtCollectionProviderId} setDebtCollectionProviderId={setDebtCollectionProviderId} token={token}/>

                            <FormSitePaymentProviders parkonomySiteCode={parkonomySiteCode}
                                                      setParkonomySiteCode={setParkonomySiteCode}
                                                      ringGoZone={ringGoZone} setRingGoZone={setRingGoZone}
                                                      parkBunnyLocationId={parkBunnyLocationId}
                                                      setParkBunnyLocationId={setParkBunnyLocationId}
                                                      justParkLocationId={justParkLocationId}
                                                      setJustParkLocationId={setJustParkLocationId}
                                                      tap2ParkLocationId={tap2ParkLocationId}
                                                      setTap2ParkLocationId={setTap2ParkLocationId}
                                                      payByPhoneLocationId={payByPhoneLocationId}
                                                      setPayByPhoneLocationId={setPayByPhoneLocationId}
                                                      ipsLocationId={ipsLocationId} setIpsLocationId={setIpsLocationId}
                                                      conviousLocationId={conviousLocationId}
                                                      setConviousLocationId={setConviousLocationId}
                                                      lookingForCarParkLocationId={lookingForCarParkLocationId}
                                                      setLookingForCarParkLocationId={setLookingForCarParkLocationId}
                                                      newParkLocationId={newParkLocationId}
                                                      setNewParkLocationId={setNewParkLocationId}
                                                      parksoLocationId={parksoLocationId}
                                                      setParksoLocationId={setParksoLocationId}
                                                      myCarPassLocationId={myCarPassLocationId}
                                                      setMyCarPassLocationId={setMyCarPassLocationId}/>

                            <FormSiteCodes iasEnabled={iasEnabled} setIasEnabled={setIasEnabled} iasIpcCode={iasIpcCode}
                                           setIasIpcCode={setIasIpcCode} bpaEnabled={bpaEnabled}
                                           setBpaEnabled={setBpaEnabled} bpaCode={bpaCode} setBpaCode={setBpaCode}
                                           pofaEnabled={pofaEnabled} setPofaEnabled={setPofaEnabled}/>

                            <FormSiteSpaces payAndDisplaySpaces={payAndDisplaySpaces}
                                            setPayAndDisplaySpaces={setPayAndDisplaySpaces}
                                            preAllocatedSpaces={preAllocatedSpaces}
                                            setPreAllocatedSpaces={setPreAllocatedSpaces}
                                            disabledSpaces={disabledSpaces} setDisabledSpaces={setDisabledSpaces}
                                            permitSpaces={permitSpaces} setPermitSpaces={setPermitSpaces}
                                            otherSpaces={otherSpaces} setOtherSpaces={setOtherSpaces}/>
                        </div>
                        <div className="card-footer border-top ">
                            <div className="row client-edit-buttons">
                                <div className="col-6 col-sm-auto ml-auto  pl-0">
                                    <div id="dashboard-actions">
                                        <Link className="btn btn-falcon-default btn-sm"
                                              to={`/organisation/${organisationId}/client/${clientId}`}><i
                                            className="fas fa-times"></i> Cancel</Link>
                                        <button type="button" className="btn btn-success btn-sm ml-2"
                                                disabled={!canSave} onClick={() => submit()}>
                                            <i className="fas fa-check"></i> Confirm
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}